module.exports = __webpack_public_path__ + "static/img/soc2.a02b545b.jpg";